var _a, _b, _c, _d, _e, _f, _g, _h;
import { __decorate, __metadata } from "tslib";
import contService from "@/core/services/contService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Material_DetalhesActions } from "@/store/enums/ContEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Material_DetalhesModule = class Material_DetalhesModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Material_DetalhesActions.POST_MATERIAL_DETALHES](data) {
        return new Promise(resolve => {
            contService.post("Material_Detalhes/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Material_DetalhesActions.PUT_MATERIAL_DETALHES](data) {
        return new Promise(resolve => {
            contService.put("Material_Detalhes/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Material_DetalhesActions.DELETE_MATERIAL_DETALHES](data) {
        return new Promise(resolve => {
            contService.delete("Material_Detalhes/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Material_DetalhesActions.DELETE_RANGE_MATERIAL_DETALHES](data) {
        return new Promise(resolve => {
            contService.delete("Material_Detalhes/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Material_DetalhesActions.FILTER_MATERIAL_DETALHES](data) {
        return new Promise(resolve => {
            contService.post("Material_Detalhes/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Material_DetalhesActions.GET_MATERIAL_DETALHES]() {
        return new Promise(resolve => {
            contService.get("Material_Detalhes/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Material_DetalhesActions.GETWITHDISABLED_MATERIAL_DETALHES]() {
        return new Promise(resolve => {
            contService.get("Material_Detalhes/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Material_DetalhesActions.GET_BY_ID_MATERIAL_DETALHES](data) {
        return new Promise(resolve => {
            contService.get("Material_Detalhes/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Material_DetalhesModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Material_DetalhesModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Material_DetalhesModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Material_DetalhesModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Material_DetalhesModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Material_DetalhesModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Material_DetalhesModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Material_DetalhesModule.prototype, _h, null);
Material_DetalhesModule = __decorate([
    Module
], Material_DetalhesModule);
export default Material_DetalhesModule;
//# sourceMappingURL=Material_DetalhesModule.js.map